<script>
	import { onMount, createEventDispatcher } from 'svelte';
  import snarkdown from 'snarkdown';
	import { fade } from 'svelte/transition';
	import { send, trash } from 'ionicons/icons/index.mjs';
  import { generateID, fetchData, deleteMessage } from '../utils/Data.svelte';

	const dispatch = createEventDispatcher();
  export let modal;
  export let tooltips;
  export let session;

  async function deleteHandler(e) {
		e.currentTarget.blur();
    let [res, err] = await fetchData("/v1/messages", {
			method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + session.token
            },
      body: JSON.stringify({
				id: modal.id
			})
		});
    deleteMessage(modal.message);
    dispatch('message', {
      type: "toast",
      data: {
        message: "Message deleted."
      }
    });
    close();
  }

  function close() {
		dispatch('message', {
            type: "modal",
            modal: null
		});
  }
</script>

<div class="modal modal-lg active">
    <div class="modal-overlay" on:click={close} aria-label="Close"></div>
    <div id="modal-container" class="modal-container">
        <div class="modal-header">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <div class="tile-title">Message</div>
                </div>
                <div class="tile-action">
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Delete" on:click={deleteHandler} aria-label="Delete"><i class="svg svg-light">{@html trash.md}</i></button>
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Close" on:click={close} aria-label="Close"><i class="icon icon-cross mt-1"></i></button>
                </div>
            </div>
        </div>
        <div class="modal-body">
          {@html snarkdown(modal.content)}
        </div>
    </div>
</div>

<style>
	.modal.modal-lg .modal-overlay {
        background: rgba(247, 248, 249, 0.75);
    }
    .modal.modal-lg .modal-container {
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        padding: 0;
    }
    .modal.modal-lg .modal-header {
        background-color: #00ab5f;
        color: #fff;
        padding: 0.2rem 0.4rem;
    }
    .modal.modal-lg .modal-header .btn.btn-link {
        color: white;
    }
    .modal.modal-lg .modal-body {
        padding: 10px;
        height: calc(100vh - 2.1rem);
    }
    ::-webkit-scrollbar {
      width: 6px;
      background-color: #f7f8f9;
    }
	  ::-webkit-scrollbar-thumb {
	  	background-color: rgba(122,129,132, 1);
    }
    #editor {
      height: 100%;
    }
</style>